import React from 'react';

import {AppBar, Box, Grid, Tab, Tabs} from '@material-ui/core';

import EfeTabpanelValues from 'commons/models/components/EfeTabpanelValues';

interface TabpanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

type Props = {
    tabIndex: number;
    data: Array<EfeTabpanelValues>;
    handleTabChange: (event: React.ChangeEvent<any>, newValue: number) => void;
};

function TabPanel(props: TabpanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role='tabpanel'
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}>
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: any) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    };
}

function EfeTabpanel(props: Props) {
    const {data, tabIndex, handleTabChange} = props;
    return (
        <Grid container spacing={2} alignContent='center' justifyContent='center' direction='row'>
            <Grid item xs={12}>
                <AppBar position='static' color='default'>
                    <Tabs
                        indicatorColor='primary'
                        textColor='primary'
                        variant='scrollable'
                        scrollButtons='auto'
                        value={tabIndex}
                        onChange={handleTabChange}>
                        {data.map((item, key) => (
                            <Tab
                                icon={item.icon}
                                key={key}
                                label={item.label}
                                {...a11yProps(item.tabIndex)}
                                disabled={item.disabled}
                            />
                        ))}
                    </Tabs>
                </AppBar>

                <Grid
                    container
                    spacing={2}
                    alignContent='center'
                    justifyContent='center'
                    direction='row'>
                    <Grid item xs={12}>
                        {data.map((item, key) => (
                            <TabPanel key={key} value={tabIndex} index={item.tabIndex}>
                                <Grid
                                    container
                                    spacing={2}
                                    direction='row'
                                    alignContent='center'
                                    justifyContent='center'>
                                    <Grid
                                        container
                                        spacing={2}
                                        alignContent='center'
                                        justifyContent='center'
                                        direction='row'>
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            {item.view}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </TabPanel>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default EfeTabpanel;
